/** LoyalPass product palette (see tailwind.config.js `theme.extend.colors`). */
export const LOYALPASS_PRIMARY_HEX = '#6366F1';
export const LOYALPASS_PRIMARY_RGB = 'rgb(99, 102, 241)';
export const LOYALPASS_ON_PRIMARY_HEX = '#ffffff';
export const LOYALPASS_ON_PRIMARY_RGB = 'rgb(255, 255, 255)';
export const LOYALPASS_CTA_HEX = '#11D0C3';

/** "LoyalPass" link color in email footers (matches backend loyalPassEmail.js). */
export const LOYALPASS_EMAIL_BRAND_LINK_COLOR = LOYALPASS_CTA_HEX;

/** Default wallet pass template colors (match LoyalPass primary). */
export const DEFAULT_PASS_BACKGROUND_COLOR = LOYALPASS_PRIMARY_HEX;
export const DEFAULT_PASS_TEXT_COLOR = LOYALPASS_ON_PRIMARY_HEX;
export const DEFAULT_PASS_BACKGROUND_RGB = LOYALPASS_PRIMARY_RGB;
export const DEFAULT_PASS_TEXT_RGB = LOYALPASS_ON_PRIMARY_RGB;
